export default {
  title: 'Brand',
  description: 'Administreaza brand',
  new: 'Brand nou',
  edit: 'Modifica',
  fields: {
    name: 'Nume',
    icon: 'Icon',
    description_placeholder: 'Text descriere brand. Minim 50 de caractere. Maxim 1000 de caractere',
    website: 'Website',
    scope_availability: 'Disponibilitate',
    value: 'Valoare',
    value_discount: 'Discount/Pret',
    discount_items: {
      price: 'Pret',
      discount: 'Discount Total',
      user_discount: 'Discount Utilizator',
      platform_discount: 'Discount Platforma'
    },
    provider: 'Provider',
    is_active_app: 'Este activ in UpMobil+',
    actions: 'Actiuni'
  },
  rules: {
    title: 'Ghid rapid – Configurare beneficii în UpMobil+',
    1: 'Comportament default: dacă nu este modificat niciun beneficiu din acest panou, toate beneficiile vor fi afișate în UpMobil+;',
    2: 'Comportament personalizat: dacă cel puțin un beneficiu este modificat, afișarea în UpMobil+ se face conform setărilor din acest panou;',
    3: 'În coloana „Este activ în UpMobil+”: Activ → beneficiul este afișat în aplicație / Inactiv → beneficiul nu este afișat;',
    4: 'Disponibilitate selectată fără perioadă → beneficiul este afișat pe perioadă nedeterminată;',
    5: 'Disponibilitate selectată cu perioadă (Data început / Data încheiere) → beneficiul este afișat doar în intervalul selectat; după expirare, nu va mai fi afișat;',
    6: '„Salvează” / „Anulează” apar doar când există modificări nesalvate;',
    7: '„Anulează” readuce beneficiul la setările default.'
  },
  errors: {
    start_date: 'Data de inceput este obligatorie',
    end_date: 'Data de incheiere este obligatorie',
    icon_required: 'Iconul este obligatoriu.',
    icon_png_required: 'Iconul trebuie sa fie un fisier PNG.',
    icon_max_size: 'Iconul nu trebuie sa depaseasca 2 MB.',
    icon_dimensions: 'Iconul trebuie sa fie exact 600px x 600px sau 600px x 300px.',
    icon_validation_pending: 'Validarea iconului este inca in curs. Te rugam sa incerci din nou.',
    icon_invalid: 'Fisierul iconului este invalid.'
  },
  modal: {
    confirm_save: 'Esti sigur ca vrei sa salvezi modificarile?',
    confirm_leave: 'Exista informatii modificate care nu au fost salvate. Confirmi parasirea paginii?',
    confirm_delete: 'Esti sigur ca vrei sa stergi brandul?',
    extra_delete: 'Brandul curent are {count_benefits} beneficii.'
  },
  tooltips: {
    description: '(min 50, max 1000)'
  },
  scope_availability: {
    benefit: 'Beneficii',
    offer: 'Oferte',
  },
  nav_tree: {
    benefits_title: 'Mapare beneficii',
    offers_title: 'Mapare oferte',
    section_hint: 'Alege una sau mai multe categorii in care va fi afisat brandul.',
    add_mapping: 'Adauga mapare',
    badge_existing: 'Existenta',
    badge_new: 'Noua',
    category: 'Categorie',
    subcategory: 'Subcategorie',
    direct_category: 'Mapeaza direct la categorie',
    no_categories: 'Nu exista categorii disponibile in NavTree pentru aceasta sectiune.',
    empty_title: 'Nu exista mapari adaugate.',
    empty_subtitle: 'Apasa pe Adauga mapare pentru a selecta categoria.',
    save_mapping: 'Salveaza',
    saving: 'Se salveaza...',
    deleting: 'Se sterge...',
    cancel: 'Anuleaza',
    save_error: 'Nu am putut salva maparea. Incearca din nou.',
    delete_error: 'Nu am putut sterge maparea. Incearca din nou.',
    mappings_saved_individually_info: 'Maparile se salveaza individual. Apasa Save pe fiecare mapare noua pentru a o activa.',
    save_info: 'Pentru ca modificarile de mapare sa intre in vigoare, apasa butonul Save.',
    errors: {
      required: 'Camp obligatoriu',
      duplicate: 'Aceasta combinatie de categorie si subcategorie exista deja',
      invalid: 'Valoare invalida',
      not_allowed: 'Maparea nu este permisa pentru acest brand',
      tree_not_found: 'NavTree-ul nu a fost gasit',
    },
  },
}
